var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningYellow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666992 13.3337H15.3337L8.00033 0.666992L0.666992 13.3337ZM8.66699 11.3337H7.33366V10.0003H8.66699V11.3337ZM8.66699 8.66699H7.33366V6.00033H8.66699V8.66699Z",
    fill: "#FFCC16"
  })));
}
export default __webpack_public_path__ + "static/media/warning-yellow.f8d6266a.svg";
export { SvgWarningYellow as ReactComponent };